import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { PlatformIcon } from './PlatformIcon';

const platformColors: Record<string, string> = {
  agropool: '#3E8538',
  agrarjobs: '#1E9D65',
  bauernzeitung: '#52AE32',
  tierwelt: '#FDBF00',
  baumatpool: '#FF4D01',
  baumaschinenpool: '#233881',
  tierinserate: '#3C8C40',
};

export type PlatformLogoProps = FlexProps & {
  platformKey?: string;
  platformName?: string;
};

export const PlatformLogo: FC<PlatformLogoProps> = ({ platformKey, platformName, ...rest }) => {
  if (!platformKey) {
    return null;
  }
  const color = platformColors[platformKey.toLowerCase()];
  return (
    <Flex align="center" gap={2} {...rest}>
      <PlatformIcon platformKey={platformKey} width={8} height={8} />
      <Text as="span" color={color} fontWeight="bold">
        {platformName}
      </Text>
    </Flex>
  );
};
